import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'

// Guard de rutas. Opcionalmente exige un permiso concreto.
export default function RequireAuth({ children, permission }) {
  const { isAuthenticated, can } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  if (permission && !can(permission)) {
    return <Navigate to="/" replace />
  }
  return children
}
